import { Type } from "@google/genai";

const sceneSchema = {
  type: Type.OBJECT,
  properties: {
    original_scene_number: { type: Type.STRING, nullable: true },
    int_ext: { type: Type.STRING, nullable: true },
    set_name: { type: Type.STRING, nullable: true },
    scene_heading_raw: { type: Type.STRING, nullable: true },
    description: { type: Type.STRING, nullable: true },
    script_pages_raw: { type: Type.STRING, nullable: true },
    cast_codes_raw: { type: Type.STRING, nullable: true },
    special_requirements: { type: Type.ARRAY, items: { type: Type.STRING } },
    script_day_raw: { type: Type.STRING, nullable: true },
    script_day_type: { type: Type.STRING, nullable: true },
    script_day_number: { type: Type.NUMBER, nullable: true },
    script_time: { type: Type.STRING, nullable: true },
    location_raw: { type: Type.STRING, nullable: true },
    location_name: { type: Type.STRING, nullable: true },
    location_address: { type: Type.STRING, nullable: true },
    location_status: { type: Type.STRING, nullable: true },
    background_artists_count: { type: Type.NUMBER, nullable: true },
    action_vehicles_count: { type: Type.NUMBER, nullable: true },
    featured_artists_count: { type: Type.NUMBER, nullable: true },
    item_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
    part_label: { type: Type.STRING, nullable: true },
    is_omitted: { type: Type.BOOLEAN, nullable: true },
    is_unscheduled: { type: Type.BOOLEAN, nullable: true },
    is_repeated: { type: Type.BOOLEAN, nullable: true },
    is_if_time_allows: { type: Type.BOOLEAN, nullable: true },
    confidence_score: { type: Type.NUMBER, nullable: true },
  },
};

export const SHOOTING_SCHEDULE_SCHEMA = {
  type: Type.OBJECT,
  properties: {
    filename: { type: Type.STRING },
    detected_document_type: { type: Type.STRING },
    classification_confidence: { type: Type.NUMBER },
    document_summary: { type: Type.STRING, nullable: true },
    global_fields: {
      type: Type.OBJECT,
      properties: {
        project_title: { type: Type.STRING, nullable: true },
        show_title: { type: Type.STRING, nullable: true },
        episode_identifiers: { type: Type.ARRAY, items: { type: Type.STRING } },
        date_mentions: { type: Type.ARRAY, items: { type: Type.STRING } },
        notes: { type: Type.ARRAY, items: { type: Type.STRING } },
      },
    },
    shooting_schedule_data: {
      type: Type.OBJECT,
      properties: {
        production_title: { type: Type.STRING, nullable: true },
        schedule_title: { type: Type.STRING, nullable: true },
        schedule_date: { type: Type.STRING, nullable: true },
        source_page_count: { type: Type.NUMBER, nullable: true },
        confidence_score: { type: Type.NUMBER, nullable: true },
        warnings: { type: Type.ARRAY, items: { type: Type.STRING } },
        raw_schedule_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
        cast_members: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              cast_code: { type: Type.STRING, nullable: true },
              character_name: { type: Type.STRING, nullable: true },
              raw_label: { type: Type.STRING, nullable: true },
              type: { type: Type.STRING, nullable: true },
            },
          },
        },
        shoot_days: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              week_number: { type: Type.NUMBER, nullable: true },
              shoot_day_number: { type: Type.NUMBER, nullable: true },
              shoot_date: { type: Type.STRING, nullable: true },
              weekday: { type: Type.STRING, nullable: true },
              call_time_start: { type: Type.STRING, nullable: true },
              call_time_end: { type: Type.STRING, nullable: true },
              day_type: { type: Type.STRING, nullable: true },
              dawn_time: { type: Type.STRING, nullable: true },
              sunrise_time: { type: Type.STRING, nullable: true },
              sunset_time: { type: Type.STRING, nullable: true },
              dusk_time: { type: Type.STRING, nullable: true },
              total_script_pages_raw: { type: Type.STRING, nullable: true },
              day_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
              unavailable_cast_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
              confidence_score: { type: Type.NUMBER, nullable: true },
              scenes: { type: Type.ARRAY, items: sceneSchema },
            },
          },
        },
        omitted_scenes: { type: Type.ARRAY, items: sceneSchema },
        unscheduled_scenes: { type: Type.ARRAY, items: sceneSchema },
      },
    },
    uncertainties: { type: Type.ARRAY, items: { type: Type.STRING } },
  },
};

export const SHOOTING_SCHEDULE_RECOVERY_SCHEMA = {
  type: Type.OBJECT,
  properties: {
    detected_document_type: { type: Type.STRING, nullable: true },
    document_summary: { type: Type.STRING, nullable: true },
    shooting_schedule_data: {
      type: Type.OBJECT,
      properties: {
        production_title: { type: Type.STRING, nullable: true },
        schedule_title: { type: Type.STRING, nullable: true },
        schedule_date: { type: Type.STRING, nullable: true },
        warnings: { type: Type.ARRAY, items: { type: Type.STRING } },
        cast_members: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              cast_code: { type: Type.STRING, nullable: true },
              character_name: { type: Type.STRING, nullable: true },
              raw_label: { type: Type.STRING, nullable: true },
              type: { type: Type.STRING, nullable: true },
            },
          },
        },
        shoot_days: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              week_number: { type: Type.NUMBER, nullable: true },
              shoot_day_number: { type: Type.NUMBER, nullable: true },
              shoot_date: { type: Type.STRING, nullable: true },
              weekday: { type: Type.STRING, nullable: true },
              call_time_start: { type: Type.STRING, nullable: true },
              call_time_end: { type: Type.STRING, nullable: true },
              day_type: { type: Type.STRING, nullable: true },
              total_script_pages_raw: { type: Type.STRING, nullable: true },
              day_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
              unavailable_cast_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
              confidence_score: { type: Type.NUMBER, nullable: true },
              scene_rows: {
                type: Type.ARRAY,
                items: {
                  type: Type.OBJECT,
                  properties: {
                    raw_text: { type: Type.STRING, nullable: true },
                    original_scene_number: { type: Type.STRING, nullable: true },
                    int_ext: { type: Type.STRING, nullable: true },
                    set_name: { type: Type.STRING, nullable: true },
                    description: { type: Type.STRING, nullable: true },
                    script_day_raw: { type: Type.STRING, nullable: true },
                    script_pages_raw: { type: Type.STRING, nullable: true },
                    cast_codes_raw: { type: Type.STRING, nullable: true },
                    location_raw: { type: Type.STRING, nullable: true },
                    background_artists_count: { type: Type.NUMBER, nullable: true },
                    action_vehicles_count: { type: Type.NUMBER, nullable: true },
                    featured_artists_count: { type: Type.NUMBER, nullable: true },
                    item_notes: { type: Type.ARRAY, items: { type: Type.STRING } },
                    confidence_score: { type: Type.NUMBER, nullable: true },
                  },
                },
              },
            },
          },
        },
        omitted_scenes: { type: Type.ARRAY, items: sceneSchema },
        unscheduled_scenes: { type: Type.ARRAY, items: sceneSchema },
      },
    },
    uncertainties: { type: Type.ARRAY, items: { type: Type.STRING } },
  },
};

export const SHOOTING_SCHEDULE_CAST_RECOVERY_SCHEMA = {
  type: Type.OBJECT,
  properties: {
    detected_document_type: { type: Type.STRING, nullable: true },
    document_summary: { type: Type.STRING, nullable: true },
    shooting_schedule_data: {
      type: Type.OBJECT,
      properties: {
        warnings: { type: Type.ARRAY, items: { type: Type.STRING } },
        cast_members: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              cast_code: { type: Type.STRING, nullable: true },
              character_name: { type: Type.STRING, nullable: true },
              raw_label: { type: Type.STRING, nullable: true },
              type: { type: Type.STRING, nullable: true },
            },
          },
        },
      },
    },
    uncertainties: { type: Type.ARRAY, items: { type: Type.STRING } },
  },
};
